function About() {
    return (
      <main>
        <div className="aboutDiv">
          <div className="section">
            <h4 className="sectionhead uppercase mainhead scrollanim">
               ABOUT US
            </h4>
            <div className="sectionbody sectionbodytext scrollanim">
            Welcome to the Pragjyotishpur University App – bridging administration, faculty, and students on a unified platform.

            </div>
          </div>
        </div>
      </main>
    )
  }
  
  export default About